export type BloqueCv =
  | 'estudios'
  | 'lineas'
  | 'experiencia'
  | 'proyectos'
  | 'publicaciones'
  | 'reconocimientos';

export type EstadoEstudioCv = 'en_curso' | 'finalizado' | '';

export interface FormacionAcademicaItem {
  tipoAntecedente: string;
  grado: string;
  institucion: string;
  pais: string;
  anioInicio: string;
  anioTermino: string;
  fechaInicio: string;
  fechaTermino: string;
  estado: EstadoEstudioCv;
}

export interface LineaInvestigacionItem {
  linea: string;
  disciplinaArea: string;
}

export interface ExperienciaItem {
  cargo: string;
  institucion: string;
  experienciaVigente: string;
  funcionesPrincipales: string;
  fechaInicio: string;
  fechaTermino: string;
}

export interface PublicacionItem {
  tipo: string;
  titulo: string;
  estructuraAutores: string;
  revistaEditorial: string;
  doiEnlace: string;
  anio: string;
  fecha: string;
}

export interface ProyectoItem {
  nombreProyecto: string;
  codigoFolio: string;
  rol: string;
  fuenteFinanciamiento: string;
  anioInicio: string;
  anioTermino: string;
  fechaInicio: string;
  fechaTermino: string;
}

export interface DistincionItem {
  nombreReconocimiento: string;
  institucionOtorga: string;
  enlaceRespaldo: string;
  anio: string;
  fecha: string;
  descripcion: string;
}

export interface DocenciaItem {
  curso: string;
  institucion: string;
  periodo: string;
}

export interface IdiomaItem {
  idioma: string;
  nivel: string;
}

export type TipoAdjuntoCV = 'cv_pdf' | 'certificado' | 'carta_recomendacion';

export interface AdjuntoCVItem {
  tipo: TipoAdjuntoCV;
  nombreArchivo: string;
  sizeKb: number;
}

export interface CVData {
  formacionAcademica: FormacionAcademicaItem[];
  lineasInvestigacion: LineaInvestigacionItem[];
  experiencia: ExperienciaItem[];
  publicaciones: PublicacionItem[];
  proyectos: ProyectoItem[];
  distinciones: DistincionItem[];
  docencia: DocenciaItem[];
  idiomas: IdiomaItem[];
  adjuntos: AdjuntoCVItem[];
  ultimoBloque: BloqueCv | '';
}

/** Claves de dominio que viajan en el PUT parcial de cada acordeón. */
export const CAMPOS_BLOQUE_CV: Record<BloqueCv, Array<keyof CVData>> = {
  estudios: ['formacionAcademica'],
  lineas: ['lineasInvestigacion'],
  experiencia: ['experiencia'],
  proyectos: ['proyectos'],
  publicaciones: ['publicaciones'],
  reconocimientos: ['distinciones'],
};

export function createEmptyCvData(): CVData {
  return {
    formacionAcademica: [],
    lineasInvestigacion: [],
    experiencia: [],
    publicaciones: [],
    proyectos: [],
    distinciones: [],
    docencia: [],
    idiomas: [],
    adjuntos: [],
    ultimoBloque: '',
  };
}

export function anioDeFecha(valor: string): string {
  const match = valor.trim().match(/^(\d{4})/);
  return match ? match[1] : '';
}

export function fechaDesdeAnio(valor: string): string {
  const texto = valor.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return texto;
  if (/^\d{4}-\d{2}$/.test(texto)) return `${texto}-01`;
  if (/^\d{4}$/.test(texto)) return `${texto}-01-01`;
  return '';
}

export function formacionAcademicaVacia(): FormacionAcademicaItem {
  return {
    tipoAntecedente: '',
    grado: '',
    institucion: '',
    pais: '',
    anioInicio: '',
    anioTermino: '',
    fechaInicio: '',
    fechaTermino: '',
    estado: '',
  };
}

export function lineaInvestigacionVacia(): LineaInvestigacionItem {
  return { linea: '', disciplinaArea: '' };
}

export function experienciaVacia(): ExperienciaItem {
  return {
    cargo: '',
    institucion: '',
    experienciaVigente: '',
    funcionesPrincipales: '',
    fechaInicio: '',
    fechaTermino: '',
  };
}

export function publicacionVacia(): PublicacionItem {
  return {
    tipo: '',
    titulo: '',
    estructuraAutores: '',
    revistaEditorial: '',
    doiEnlace: '',
    anio: '',
    fecha: '',
  };
}

export function proyectoVacio(): ProyectoItem {
  return {
    nombreProyecto: '',
    codigoFolio: '',
    rol: '',
    fuenteFinanciamiento: '',
    anioInicio: '',
    anioTermino: '',
    fechaInicio: '',
    fechaTermino: '',
  };
}

export function distincionVacia(): DistincionItem {
  return {
    nombreReconocimiento: '',
    institucionOtorga: '',
    enlaceRespaldo: '',
    anio: '',
    fecha: '',
    descripcion: '',
  };
}
